/** Locales with full www landing page translations */
export const wwwLocales = ['en', 'es', 'ca', 'it'] as const;
